// removed by extract-text-webpack-plugin
module.exports = {"projects":"PersonalProjects__projects__iw7GK","site-section-title":"PersonalProjects__site-section-title__3WnQr","fadeInUp":"PersonalProjects__fadeInUp__28FZj","appCardContainer":"PersonalProjects__appCardContainer___dQDl"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Sections/PersonalProjects/PersonalProjects.css
// module id = 297
// module chunks = 0